import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRouter, useRoute } from '@/hooks/useRouter'
import NavTopItems from './NavTopItems.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavTop',
  setup(__props) {

const router = useRouter()

const left = computed(() => {
  if (router.options.routes && router.options.routes.length > 1) {
    return router.options.routes.filter((i) => !i.meta?.hide).slice(1, 7)
  }
  return []
})
const right = computed(() => {
  if (router.options.routes && router.options.routes.length > 1) {
    return router.options.routes.filter((i) => !i.meta?.hide).slice(7, 13)
  }
  return []
})

return { __sfc: true,router, left, right, NavTopItems }
}

})